module.exports = __webpack_public_path__ + "assets/img/12.a71e4c81.png";